import {formatterDollarUSNoDecimal, formatterInt, formatterPercent} from "../../../../utils/formatters";
import {MetricKey} from "./types";

const PCT_SIGNED_FMT = new Intl.NumberFormat("en-US", {style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1, signDisplay: "exceptZero"});
const CURRENCY_SIGNED_FMT = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 0, signDisplay: "exceptZero"});
const INT_SIGNED_FMT = new Intl.NumberFormat("en-US", {maximumFractionDigits: 0, signDisplay: "exceptZero"});
const PP_SIGNED_FMT = new Intl.NumberFormat("en-US", {maximumFractionDigits: 1, signDisplay: "exceptZero"});

const NA_LABEL = "N/A";

export function formatMetricValue(value: number | null | undefined, metric: MetricKey): string {
    if (value == null) {
        return NA_LABEL;
    }
    switch (metric) {
        case "occupancyPct":
            return formatterPercent.format(value / 100);
        case "unitCount":
            return formatterInt.format(value);
        case "marketRent":
        case "inPlaceRent":
            return formatterDollarUSNoDecimal.format(value);
    }
}

export function formatAbsoluteChange(value: number | null | undefined, metric: MetricKey): string {
    if (value == null) {
        return NA_LABEL;
    }
    switch (metric) {
        case "occupancyPct":
            return `${PP_SIGNED_FMT.format(value)} pts`;
        case "unitCount":
            return INT_SIGNED_FMT.format(value);
        case "marketRent":
        case "inPlaceRent":
            return CURRENCY_SIGNED_FMT.format(value);
    }
}

export function formatPercentChange(value: number | null | undefined): string {
    if (value == null) {
        return NA_LABEL;
    }
    return PCT_SIGNED_FMT.format(value);
}
